module.exports = "#ipay88-button {\n    border-radius: 15px;\n    padding: 3px 0px;\n    width: 150px;\n    margin: auto;\n  }"